import { Box, Skeleton } from '@mui/material';

function EmptyBookings() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '89vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: '2px',
        borderRadius: '16px',
        overflowX: 'auto',
        border: '1px solid #FFDDC8',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: '25px',
          width: '100%',
          maxWidth: '500px',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <Skeleton sx={{ borderRadius: '5px' }} variant="circular" width={60} height={60} />
        </Box>
        <Box
          sx={{
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Skeleton
            variant="text"
            width="80%"
            height={30}
            sx={{ margin: '2px 0', textAlign: 'center', borderRadius: '5px' }}
          />
          <Skeleton sx={{ borderRadius: '5px' }} variant="text" width="60%" height={25} />
        </Box>
        <Box
          sx={{
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Skeleton sx={{ borderRadius: '5px' }} variant="text" width="90%" height={20} />
          <Skeleton sx={{ borderRadius: '5px' }} variant="text" width="70%" height={20} />
          <Skeleton sx={{ borderRadius: '5px' }} variant="text" width="80%" height={20} />
        </Box>
        <Box
          sx={{
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Skeleton sx={{ borderRadius: '5px' }} variant="rectangular" width="40%" height={50} />
        </Box>
      </Box>
    </Box>
  );
}

export default EmptyBookings;
